
import { css } from 'lit';
export default css`
:host {margin-left: auto;margin-right: auto;display: block;width: 100%;padding-left: 1rem;padding-right: 1rem
}@media (min-width: 1024px) {:host {max-width: 1024px
    }:host {padding-left: 7rem;padding-right: 7rem
    }
}@media (min-width: 1200px) {:host {max-width: 1200px
    }:host {padding-left: 10rem;padding-right: 10rem
    }
}@media (min-width: 1366px) {:host {max-width: 1366px
    }
}

.header-wrapper__inner {padding-right: 0px
}
`;